import React from 'react';
import { useIntl } from 'react-intl';
import { LoadingSkeleton } from '@eventbrite/legacy-infra.loading-skeleton';
import { DOM_IDS } from '@/components/_shared/constants';
import { useMoreOrganizerEventsSectionModel } from '../hooks';
import type { MoreOrganizerEventsProps } from '../MoreOrganizerEvents';
import { MoreOrganizerEventsCarousel } from './components/MoreOrganizerEventsCarousel';
import styles from './MoreOrganizerEventsRedesign.module.scss';

export const MoreOrganizerEventsRedesign = ({ eventId, isBodyRendered, eventBasicInfo }: MoreOrganizerEventsProps) => {
  const { formatMessage } = useIntl();
  const { affiliateCode, containerRef, eventsToShow, isLoading } = useMoreOrganizerEventsSectionModel({
    eventBasicInfo,
    eventId,
    isBodyRendered,
  });

  if (isLoading) {
    return (
      <div className={styles.emptyState} id={DOM_IDS.MORE_ORGANIZER_EVENTS} ref={containerRef}>
        <LoadingSkeleton height={355} />
      </div>
    );
  }

  if (eventsToShow.length === 0) {
    return (
      <div aria-hidden="true" className={styles.emptyState} id={DOM_IDS.MORE_ORGANIZER_EVENTS} ref={containerRef} />
    );
  }

  return (
    <section
      className={styles.section}
      data-testid="more-organizer-events-redesign"
      id={DOM_IDS.MORE_ORGANIZER_EVENTS}
      ref={containerRef}
    >
      <MoreOrganizerEventsCarousel
        affiliateCode={affiliateCode}
        eventsToShow={eventsToShow}
        formatMessage={formatMessage}
      />
    </section>
  );
};
